import React from "react";
import PulseLoader from "react-spinners/PulseLoader";
import TertiaryLinkArrowIcon from "../../../../../../assets/images/researcher_app/dashboard/tertiary_link_arrow.png";


function PrimaryButton(props) {
    const baseClass = "primary-button";
    const style = props.style || {};

    const cssClass = props.buttonClasses ? `${baseClass} ${props.buttonClasses}` : baseClass;
    return (
        <button className={cssClass} onClick={props.onClick} disabled={props.submitLoading} style={style}>
            {props.submitLoading ? "Loading..." : props.text}
        </button>
    )
}

function SecondaryButton(props) {
    return (
        <button className="secondary-button" onClick={props.onClick} disabled={props.submitLoading} style={props.style || {}}>
            {props.submitLoading ? "Loading..." : props.text}
        </button>
    )
}

function TertiaryButton(props) {
    const style = props.style || {};

    return (
        <button className="tertiary-button" onClick={props.onClick} disabled={props.submitLoading} style={style}>
            {props.submitLoading ? "Loading..." : props.text}
        </button>
    )
}

function WhiteButton(props) {
    const style = props.style || {};

    return (
        <button className="white-button" onClick={props.onClick} disabled={props.submitLoading} style={style}>
            {props.submitLoading ? "Loading..." : props.text}
        </button>
    )

}

function PurpleSecondaryButton(props) {
    const style = props.style || {};

    return (
        <button className="secondary-button purple-button" onClick={props.onClick} disabled={props.submitLoading} style={style}>
            {props.submitLoading ? "Loading..." : props.text}
        </button>
    )

}

function NewPrimaryButton(props) {
    return (
        <button className="researcher-primary-button" type={props.buttonType} onClick={props.onClick} disabled={props.disabled || props.submitting} style={props.style || {}}>
            <div className={"researcher-primary-button-inner-line" + (props.disabled || props.submitting ? " disabled" : "")} >
                {props.submitting ? <SmallLoadingIcon /> : props.text}
            </div>
        </button>
    )
}

function SmallLoadingIcon() {
    return (
        <div className="centered-loading">
            <div className="flex-fill">
                <div className="d-flex flex-column align-items-center justify-content-center row-gap-2">
                    <div>
                        <PulseLoader color="white" aria-label="Loading Spinner" size={8} />
                    </div>
                </div>
            </div>
        </div>
    )
}

function TertiaryLink(props) {

    return (
        <div className="tertiary-link-container" onClick={props.onClick}  >
            <div className="tertiary-link-text">
                {props.text}
            </div>
            <div className="tertiary-link-arrow">
                <img src={TertiaryLinkArrowIcon} alt="Arrow Right" />
            </div>
        </div>
    )

}

export { PrimaryButton, SecondaryButton, TertiaryButton, WhiteButton, NewPrimaryButton, TertiaryLink, PurpleSecondaryButton };